"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NavItem = void 0;

var _theming = require("@storybook/theming");

var _styles = require("../shared/styles");

var _LinkWithWrapper = require("../LinkWithWrapper");

var colorMap = {
  "default": _styles.color.dark,
  primary: _styles.color.secondary,
  inverse: _styles.color.lightest
};
var NavItem = ( /*#__PURE__*/0, _theming.styled)(_LinkWithWrapper.LinkWithWrapper, process.env.NODE_ENV === "production" ? {
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== 'active';
  },
  target: "e1ap00re0"
} : {
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== 'active';
  },
  target: "e1ap00re0",
  label: "NavItem"
})(_styles.text.regularBold, ";display:inline-flex;align-items:center;text-align:center;padding:6px 8px;color:", function (props) {
  return props.monochrome ? _styles.color.lightest : colorMap[props.variant];
}, ";text-decoration:none;border-radius:", _styles.spacing.borderRadius.small, "px;transition:background-color 150ms ease-out,color 150ms ease-out;outline:0;", function (props) {
  return props.active && /*#__PURE__*/(0, _theming.css)("color:", props.monochrome ? _styles.color.lightest : _styles.color.secondary, ";background-color:", props.monochrome ? 'rgba(255, 255, 255, 0.14)' : 'rgba(30, 167, 253, 0.07)', ";" + (process.env.NODE_ENV === "production" ? "" : ";label:NavItem;"));
}, ";", function (props) {
  return props.monochrome ? /*#__PURE__*/(0, _theming.css)("&:hover,&:focus{color:", _styles.color.lightest, ";background-color:rgba(255, 255, 255, 0.14);}&:active{color:", _styles.color.lightest, ";background-color:rgba(255, 255, 255, 0.07);}" + (process.env.NODE_ENV === "production" ? "" : ";label:NavItem;")) : /*#__PURE__*/(0, _theming.css)("&:hover,&:focus{color:", _styles.color.secondary, ";background-color:rgba(30, 167, 253, 0.14);}&:active{color:", _styles.color.secondary, ";background-color:rgba(30, 167, 253, 0.07);}" + (process.env.NODE_ENV === "production" ? "" : ";label:NavItem;"));
}, ";");
exports.NavItem = NavItem;
NavItem.defaultProps = {
  variant: 'default'
};